import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Topbar } from './components/topbar';
import { Banner } from './components/banner';
import { Carousel } from './components/carousel';
import { Footer } from './components/footer';
import FormIndex from './components/forms/formIndex';
import { Destination } from './components/destination';
import { ButtonUp } from './components/button_up';
import { Carts } from './components/sections/cars';
import { useTranslation } from 'react-i18next';
import { Mantenimiento } from './components/mantenimiento/mantenimiento';

function App() {
  const { t, i18n, ready } = useTranslation();
  if (process.env.REACT_APP_MANTENIMIENTO === 'true') {
    return (
      <div className="bg-dark text-white vh-100 d-flex align-items-center justify-content-center">
        <div className="container text-center">
          <Mantenimiento />
        </div>
      </div>
    );
  }

  if(ready){
    return (
      <div className="App">
          <Topbar />
          <Banner />
          <Carousel />
          <FormIndex />
          <Carts />
          {/* <Destination /> */}
          <ButtonUp />
          <Footer />
      </div>
    );
  }
  return <span>Loading...</span>;
}

export default App;
